import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function Support () {

  return (
    <Row className="justify-content-center">
      <Col md={12} lg={6}>
        <h3>Support Request</h3>
        <p>Also consider joining the <a href="https://t.co/qxoFrCfVHM">RFID Hacking by Iceman Discord Server</a></p>

        <Form data-netlify="true" name="support" method="POST" action="/thankyou">
          <input type="hidden" name="form-name" value="support" />
          <Form.Group controlId="name">
            <Form.Label>Name</Form.Label>
            <Form.Control type="text" name="name" placeholder="Enter name" />
          </Form.Group>

          <Form.Group as={Row} controlId="formHorizontalBotField" hidden>
            <Form.Label column sm={2}>
              Don’t fill this out if you’re human:
            </Form.Label>
            <Col sm={6}>
              <Form.Control name="bot-field" />
            </Col>
          </Form.Group>

          <Form.Group controlId="email">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" name="email" placeholder="Enter email" />
            <Form.Text className="text-muted">
              For contacting you to get more details or resolve the issue.
            </Form.Text>
          </Form.Group>

          <Form.Group controlId="firmware">
            <Form.Label>Firmware version</Form.Label>
            <Form.Control type="text" name="firmware" placeholder="Enter firmware version" />
          </Form.Group>

          <Form.Group controlId="hear">
            <Form.Label>What can I help you with?</Form.Label>
            <Form.Control as="textarea" name="details" rows={2} placeholder="All the details you can think of to help me reproduce and fix the problem" />
          </Form.Group>

          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Form>
      </Col>
    </Row>
  );
}

export default Support;
